module.exports = __webpack_public_path__ + "img/rockola_button.18fb9aa9.png";